import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { loadModules } from 'esri-loader';

const styles =  {
  container: {
    padding: 0,
    margin: 0,
    height: '93vh',
    width: '100%'
  },
  options: {
    top: '50px',
    color: '#444',
    height: 'auto',
    fontFamily: 'arial',
    right: '20px',
    margin: '5px',
    padding: '10px',
    position: 'absolute',
    width: '115px',
    zIndex: '40',
    border: 'solid 2px #666',
    borderRadius: '4px',
    backgroundColor: '#fff'
  },
  button: {
    display: 'block'
  },
  mainWindow: {
    padding: '.5em',
    backgroundColor: '#fff',
  },
}
const options = { css: true };

//VIEW's and LAYER's
let map;
let view = null;

class ArcGisMap extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidMount() {
    loadModules([
      "esri/config",
      "esri/Map",
      "esri/views/MapView",
      "esri/widgets/Expand",
      "esri/request",
      "esri/layers/FeatureLayer",
      "esri/layers/support/Field",
      "esri/Graphic"
    ], options)
      .then(([esriConfig, Map, MapView, Expand, request, FeatureLayer, Field, Graphic]) => {

        var portalUrl = "https://www.arcgis.com";

        document.getElementById("uploadForm").addEventListener("change", function (event) {
          var fileName = event.target.value.toLowerCase();

          if (fileName.indexOf(".zip") !== -1) {//is file a zip - if not notify user
            generateFeatureCollection(fileName);
          }
          else {
            document.getElementById('upload-status').innerHTML = '<p style="color:red">Add shapefile as .zip file</p>';
          }
        });

        map = new Map({
          basemap: "streets"
        });

        view = new MapView({
          center: [-50.70281064022086, -10.477802433502271],
          container: "viewDiv",
          map: map,
          zoom: 4,
          popup: {
            defaultPopupTemplateEnabled: true
          }
          //spatialReference: SpatialReference.WGS84
        });
        //view.popup.autoOpenEnabled = false;

        // var map = new Map({
        //   basemap: "dark-gray-vector"
        // })

        // var view = new MapView({
        //   center: [-41.647, 36.41],
        //   zoom: 2,
        //   map: map,
        //   container: "viewDiv",
        //   popup: {
        //     defaultPopupTemplateEnabled: true
        //   }
        // });

        var fileForm = document.getElementById("mainWindow");

        var expand = new Expand({
          expandIconClass: "esri-icon-upload",
          view: view,
          content: fileForm
        })

        view.ui.add(expand, "top-right");

        function generateFeatureCollection (fileName) {
          var name = fileName.split(".");
          // Chrome and IE add c:\fakepath to the value - we need to remove it
          // see this link for more info: http://davidwalsh.name/fakepath
          name = name[0].replace("c:\\fakepath\\", "");

          document.getElementById('upload-status').innerHTML = '<b>Loading </b>' + name;

          // define the input params for generate see the rest doc for details
          // https://developers.arcgis.com/rest/users-groups-and-items/generate.htm
          var params = {
            'name': name,
            'targetSR': view.spatialReference,
            'maxRecordCount': 30000,
            'enforceInputFileSizeLimit': true,
            'enforceOutputJsonSizeLimit': true
          };

          // generalize features to 10 meters for better performance
          params.generalize = true;
          params.maxAllowableOffset = 10;
          params.reducePrecision = true;
          params.numberOfDigitsAfterDecimal = 0;

          var myContent = {
            'filetype': 'shapefile',
            'publishParameters': JSON.stringify(params),
            'f': 'json',
          };

          // use the REST generate operation to generate a feature collection from the zipped shapefile
          request(portalUrl + '/sharing/rest/content/features/generate', {
            query: myContent,
            body: document.getElementById('uploadForm'),
            responseType: 'json'
          })
          .then(function (response) {
              var layerName = response.data.featureCollection.layers[0].layerDefinition.name;
              document.getElementById('upload-status').innerHTML = '<b>Loaded: </b>' + layerName;
              addShapefileToMap(response.data.featureCollection);
            })
            .catch(errorHandler);
        }

        function errorHandler (error) {
          document.getElementById('upload-status').innerHTML =
          "<p style='color:red;max-width: 500px;'>" + error.message + "</p>";
        }

        function addShapefileToMap (featureCollection) {
          // add the shapefile to the map and zoom to the feature collection extent
          // if you want to persist the feature collection when you reload browser, you could store the
          // collection in local storage by serializing the layer using featureLayer.toJson()
          // see the 'Feature Collection in Local Storage' sample for an example of how to work with local storage
          var sourceGraphics = [];

          var layers = featureCollection.layers.map(function (layer) {

            var graphics = layer.featureSet.features.map(function(feature){
              return Graphic.fromJSON(feature);
            })
            sourceGraphics = sourceGraphics.concat(graphics);
            var featureLayer = new FeatureLayer({
              objectIdField: "FID",
              source: graphics,
              fields: layer.layerDefinition.fields.map(function(field) {
              return Field.fromJSON(field);
              })
            });
            return featureLayer;
            // associate the feature with the popup on click to enable highlight and zoom to
          });
          map.addMany(layers);
          view.goTo(sourceGraphics)
          .catch(function(error){
            if (error.name != "AbortError"){
              console.error(error);
            }
          });

          document.getElementById('upload-status').innerHTML = "";
        }
      });
  }


  render() {

    return (
      <div id="viewDiv" style={styles.container}>
        <div id="mainWindow" style={styles.mainWindow}>
          <div style={{paddingLeft: '4px'}}>
            <p>Inserir um shapefile (.zip) no mapa</p>
            <p>
              Para mais detalhes sobre os Shapefiles e limitações 
              <a target='_blank' href="https://doc.arcgis.com/en/arcgis-online/reference/shapefiles.htm"> clique aqui</a>
            </p>
            <p></p>
            <form encType="multipart/form-data" method="post" id="uploadForm">
              <div className="field">
                <label className="file-upload">
                  <span><strong>Selecionar um arquivo</strong></span>
                  <input type="file" name="file" id="inFile" />
                </label>
              </div>
            </form>
            <span className="file-upload-status" style={{opacity: '1'}} id="upload-status"></span>
            <div id="fileInfo"> </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation('common')(ArcGisMap);